export function getPasswordValidationState(password) {
  const value = String(password || "");
  return [
    { key: "length", label: "At least 8 characters", isValid: value.length >= 8 },
    { key: "uppercase", label: "One uppercase letter", isValid: /[A-Z]/.test(value) },
    { key: "number", label: "One number", isValid: /\d/.test(value) },
    { key: "special", label: "One special character", isValid: /[^A-Za-z0-9]/.test(value) },
  ];
}

export const isStrongPassword = (password) =>
  getPasswordValidationState(password).every((rule) => rule.isValid);
